/**
 * Transforms the size given in pixels to a rem value that can be used in styles.
 * Uses the default base font size for browsers of 16px for the calculation.
 */
export function remCalc(sizeInPx: number): string {
  const sizeInRem = sizeInPx / 16;
  return `${sizeInRem}rem`;
}
